// LLM & Reports v3.2 §9 — typed wrapper over the backend Improve /
// Expand endpoints. Both routes share the same request and response
// shape; the route picks Improve vs Expand.
//
// Errors are surfaced as ApiError per the shared client. The 429
// response carries the standard Retry-After header which the
// AnswerAssistantModal renders as "limit resets at midnight UTC."

import { api } from "./client";

export type AnswerAssistantAction = "improve" | "expand";

export interface AnswerAssistantRefinementTurn {
  userInstruction: string;
  assistantOutput: string;
}

export interface AnswerAssistantRequest {
  originalText: string;
  refinementHistory?: AnswerAssistantRefinementTurn[] | null;
}

export interface AnswerAssistantResult {
  draft: string;
  tokensUsed: number;
  modelUsed: string;
  draftsUsedToday: number;
  dailyDraftLimit: number;
  remainingDailyQuota: number;
  action: "Improve" | "Expand";
}

export const answerAssistantApi = {
  improve: (
    submissionId: string,
    questionId: string,
    body: AnswerAssistantRequest,
  ) =>
    api.post<AnswerAssistantResult>(
      `/reports/submissions/${submissionId}/questions/${questionId}/improve`,
      body,
    ),

  expand: (
    submissionId: string,
    questionId: string,
    body: AnswerAssistantRequest,
  ) =>
    api.post<AnswerAssistantResult>(
      `/reports/submissions/${submissionId}/questions/${questionId}/expand`,
      body,
    ),
};
